module.exports = __webpack_public_path__ + "static/media/SPACE.2b0c6b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/keyboard/SPACE.png
// module id = 187
// module chunks = 0